/* istanbul ignore file */
import { css } from 'styled-components';

export const videoWrapper = css`
  aspect-ratio: 16 / 9;
  position: relative;
`;

export const iframe = css`
  width: 100%;
  height: 100%;
`;

export const button = css`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  width: 100%;
`;

export const thumbnail = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const hidden = css`
  display: none;
`;
